import { render } from "./TotalPlatformUsers.vue?vue&type=template&id=6b119897&ts=true"
import script from "./TotalPlatformUsers.vue?vue&type=script&lang=ts"
export * from "./TotalPlatformUsers.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\trackzone\\Admin_panel\\admin panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__